import { Application } from "@hotwired/stimulus"
import "flowbite/dist/flowbite.turbo"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }
